/* Farmers market page (sections/fm-market.liquid): save (heart), reviews form, carousels. */
(function () {
  'use strict';
  var FAV_KEY = 'vg_fm_favorites_v1';     // same list as the finder's hearts

  // ------------------------------------------------------------------ back link (top of the page)
  // Server default: "Market finder" (near this market). Came from the finder: "Back to results" keeps its filters.
  // Came from another page on this site: "Back". Both use history.back() so the scroll position is kept.
  var back = document.querySelector('[data-fm-back]');
  if (back && document.referrer) {
    try {
      var ref = new URL(document.referrer);
      if (ref.origin === location.origin && ref.pathname + ref.search !== location.pathname + location.search) {
        var label = back.querySelector('[data-fm-back-label]');
        var fromFinder = ref.pathname.indexOf('/pages/farmers-market-finder') === 0;
        if (label) label.textContent = fromFinder ? 'Back to results' : 'Back';
        back.href = ref.pathname + ref.search;
        back.setAttribute('data-fm-back-mode', fromFinder ? 'finder' : 'site');
        back.addEventListener('click', function (e) {
          if (history.length > 1) { e.preventDefault(); history.back(); }
        });
      }
    } catch (err) { /* no usable referrer */ }
  }

  // ------------------------------------------------------------------ heart
  function favs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function paint(btn, on) {
    var name = btn.getAttribute('data-name') || 'this market';
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + name + (on ? ' from saved markets' : ' to saved markets'));
    btn.title = on ? 'Saved' : 'Save';
    var label = btn.querySelector('.fm-fav__label');
    if (label) label.textContent = on ? 'Saved' : 'Save';
  }
  Array.prototype.forEach.call(document.querySelectorAll('.fm-fav--page[data-fm-fav]'), function (btn) {
    var id = btn.getAttribute('data-fm-fav');
    paint(btn, Object.prototype.hasOwnProperty.call(favs(), id));
    btn.addEventListener('click', function () {
      var f = favs();
      var on = !Object.prototype.hasOwnProperty.call(f, id);
      if (on) {
        var lat = parseFloat(btn.getAttribute('data-lat')), lng = parseFloat(btn.getAttribute('data-lng'));
        f[id] = { name: btn.getAttribute('data-name') || '', url: btn.getAttribute('data-url') || location.pathname,
          city: btn.getAttribute('data-city') || '', state: btn.getAttribute('data-state') || '',
          lat: isNaN(lat) ? null : lat, lng: isNaN(lng) ? null : lng, saved: new Date().toISOString() };
      } else {
        delete f[id];
      }
      try { localStorage.setItem(FAV_KEY, JSON.stringify(f)); } catch (e) { /* private mode */ }
      paint(btn, on);
      window.dispatchEvent(new CustomEvent('fm:favorites', { detail: { favorites: f } }));
    });
    window.addEventListener('storage', function (e) {
      if (e.key === FAV_KEY) paint(btn, Object.prototype.hasOwnProperty.call(favs(), id));
    });
  });

  // ------------------------------------------------------------------ carousels
  Array.prototype.forEach.call(document.querySelectorAll('[data-fm-shuffle]'), function (track) {
    var keep = parseInt(track.getAttribute('data-fm-shuffle'), 10) || 8;
    var items = Array.prototype.slice.call(track.children);
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = items[i]; items[i] = items[j]; items[j] = t;
    }
    items.forEach(function (li, k) { track.appendChild(li); if (k >= keep) li.remove(); });
  });
  Array.prototype.forEach.call(document.querySelectorAll('.fm-row'), function (row) {
    var track = row.querySelector('[data-fm-track]');
    var btns = row.querySelectorAll('[data-fm-scroll]');
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      btns[0].disabled = track.scrollLeft <= 2;
      btns[1].disabled = track.scrollLeft >= max;
      row.classList.toggle('fm-row--fits', max <= 0);
    }
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        track.scrollBy({ left: Number(b.getAttribute('data-fm-scroll')) * track.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  // ------------------------------------------------------------------ reviews
  var allBtn = document.querySelector('[data-fm-rv-all]');
  if (allBtn) allBtn.addEventListener('click', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.fm-rv--more'), function (li) { li.hidden = false; });
    allBtn.remove();
  });

  var form = document.querySelector('[data-fm-review-form]');
  if (!form) return;
  var details = form.closest('details');
  var status = form.querySelector('[data-fm-rv-status]');
  var body = form.querySelector('textarea[name="body"]');
  var chars = form.querySelector('[data-fm-rv-chars]');
  var openedAt = Date.now();
  if (details) details.addEventListener('toggle', function () { if (details.open) openedAt = Date.now(); });
  if (location.hash === '#write-review' && details) details.open = true;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#write-review"]');
    if (a && details) { details.open = true; }
  });

  body.addEventListener('input', function () {
    var n = body.value.trim().length;
    chars.textContent = n < 20 ? (20 - n) + ' more characters' : n + ' / 2000';
  });

  function picked(group) {        // '' when unanswered or "Not sure"
    var el = form.querySelector('input[name="' + group + '"]:checked');
    return el ? el.value : '';
  }

  function say(msg, bad) {
    status.textContent = msg;
    status.classList.toggle('is-bad', !!bad);
  }

  function resize(file) {        // -> data URL, longest side 1600px, JPEG
    return new Promise(function (resolve) {
      if (!/^image\//.test(file.type) || file.size > 25 * 1024 * 1024) return resolve(null);
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var scale = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * scale);
        c.height = Math.round(img.naturalHeight * scale);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        resolve(c.toDataURL('image/jpeg', 0.82));
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(null); };
      img.src = url;
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var d = form.dataset;
    var rating = form.querySelector('input[name="rating"]:checked');
    var text = body.value.trim();
    var name = form.elements.name.value.trim();
    var email = form.elements.email.value.trim();
    if (!rating) return say('Pick a star rating.', true);
    if (text.length < 20) { body.focus(); return say('Please write at least a sentence or two (20+ characters).', true); }
    if (!name) { form.elements.name.focus(); return say('Add the name to show with your review.', true); }
    if (email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { form.elements.email.focus(); return say('That email address looks wrong.', true); }
    var files = Array.prototype.slice.call(form.elements.photos.files || [], 0, 3);
    var btn = form.querySelector('button[type="submit"]');
    btn.disabled = true;
    say(files.length ? 'Preparing photos...' : 'Sending...');
    Promise.all(files.map(resize)).then(function (photos) {
      var payload = {
        token: d.token, market_id: d.marketId, market_handle: d.marketHandle, market_name: d.marketName,
        rating: Number(rating.value), title: form.elements.title.value.trim(), body: text, name: name, email: email,
        visited: form.elements.visited.value, photos: photos.filter(Boolean), website: form.elements.website.value,
        pets: picked('pets'), parking: picked('parking'),
        elapsed: Date.now() - openedAt, page: location.pathname
      };
      say('Sending...');
      // text/plain keeps this a "simple" request (no CORS preflight), which Apps Script web apps need
      return fetch(d.url, { method: 'POST', body: JSON.stringify(payload), headers: { 'Content-Type': 'text/plain;charset=utf-8' } });
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (!res || !res.ok) throw new Error((res && res.error) || 'Something went wrong.');
      form.innerHTML = '<p class="fm-rv-thanks"><strong>Thanks for your review!</strong> It will appear here after a quick check.</p>';
    }).catch(function (err) {
      btn.disabled = false;
      say((err && err.message && !/fetch|network/i.test(err.message) ? err.message : 'Your review could not be sent. Please try again.'), true);
    });
  });
})();
